// src/lib/consommables-helpers.js — ADR-210 (raccourci dépôt consommables)
//
// Source UNIQUE de la répartition des consommables Kit d'accueil / Opérationnel
// (depuis cfg.consommables), partagée par l'onglet Stock (StockTab/SaisirDepotModal)
// ET le raccourci dépôt dans la checklist ménage (ChecklistRunModal). Garantit que
// les deux écrans voient exactement les mêmes produits/catégories.

// Sépare cfg.consommables en { kitProduits, operProduits }.
// Prédicat IDENTIQUE à l'ancien StockTab (l.81-82) : `(c.categorie ?? c.type)`.
// Tolère cfg null/absent → listes vides (garde anti-crash, ex. contexte admin
// sans cfg threadé).
export function splitConsommables(cfg) {
  const all = Array.isArray(cfg?.consommables) ? cfg.consommables : []
  return {
    kitProduits: all.filter((c) => (c.categorie ?? c.type) === "kit_accueil"),
    operProduits: all.filter((c) => (c.categorie ?? c.type) === "operationnel"),
  }
}

// Clamp PUR d'une quantité saisie dans [0, max] (entier).
// Retourne { value, clamped } : `clamped`=true si la saisie dépassait `max`
// (le caller déclenche alors son warning « stock insuffisant »).
export function clampDepotQty(n, max) {
  const v = Math.max(0, Math.floor(Number(n) || 0))
  const m = Math.max(0, Math.floor(Number(max) || 0))
  if (v > m) return { value: m, clamped: true }
  return { value: v, clamped: false }
}


// Le NOM d'un produit du catalogue — S-a (tri Dimitri 2026-08-21) : un nom
// perdu se DIT (« produit retiré du catalogue »), l'IDENTIFIANT TECHNIQUE ne
// sort JAMAIS à l'écran (règle C-1 étendue).
export function nomProduit(cfg, csId) {
  const tous = Array.isArray(cfg?.consommables) ? cfg.consommables : []
  const c = tous.find((x) => x?.id === csId)
  return (c && c.nom) || (csId ? 'produit retiré du catalogue' : '')
}
